export function formatSkyxPlayerDisplayName(
  name: string | null | undefined
): string {
  const trimmed = (name ?? '').trim();
  if (!trimmed) return 'Player#';
  const suffix = trimmed.length <= 4 ? trimmed : trimmed.slice(-4);
  return `Player#${suffix}`;
}
